import { QueryClientProvider } from '@tanstack/react-query';
import ConfigProvider from 'antd/es/config-provider';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router';
import { Suspense, useEffect } from 'react';
import { getAntdLanguage } from 'src/i18n';
import queryClient from 'src/modules/shared/reactQuery/reactQuery';
import { configureStore } from 'src/modules/store';
import 'src/theme/global.css';
import { history } from 'src/view/shared/routes/helpers';
import { useTheme } from './theme/ThemeContext';

// Imported statically: it is needed on every load, so lazy
// loading only added one more request to the startup chain.
import RoutesComponent from 'src/view/shared/routes/RoutesComponent';

const store = configureStore();

const App = () => {
  const { themeColor } = useTheme();

  // Feeds the nprogress bar color in src/theme/global.css.
  useEffect(() => {
    const root = document.documentElement.style;
    if (themeColor) {
      root.setProperty('--app-accent', themeColor);
    } else {
      root.removeProperty('--app-accent');
    }
  }, [themeColor]);

  return (
    <ConfigProvider
      locale={getAntdLanguage()}
      theme={{
        token: {
          colorPrimary: themeColor,
          colorLink: themeColor,
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {/* @ts-ignore */}
          <HistoryRouter history={history}>
            <Suspense>
              <RoutesComponent />
            </Suspense>
          </HistoryRouter>
        </Provider>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
